import leadTracking from '@titanio/lead-tracking'

const mount = () => {
  leadTracking.mount()
  leadTracking.setEventListenerFlow()
}

export default { mount }
